'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const modal_types = require('../modal.types.js');

var handlePosition = function handlePosition(_ref) {
  var position = _ref.position;
  if (!position) {
    return styled.css(["position:relative;"]);
  } else {
    var positionString = Object.keys(position).reduce(function (accumulatedPositions, positionKey) {
      return "".concat(accumulatedPositions, " ").concat(positionKey, ": ").concat(position[positionKey], ";");
    }, '');
    return styled.css(["position:fixed;", ""], positionString);
  }
};
var ModalContentContainer = styled__default.div.attrs({
  tabIndex: 0
}).withConfig({
  displayName: "modalContentstyle__ModalContentContainer",
  componentId: "sc-iz7raj-0"
})(["&:focus{outline:none;}", ";", ";", ";", " ", ""], handlePosition, function (_ref2) {
  var height = _ref2.height;
  return height && styled.css(["height:", ";"], height);
}, function (_ref3) {
  var width = _ref3.width;
  return width && styled.css(["width:", ";"], width);
}, function (_ref4) {
  var hideCloseButton = _ref4.hideCloseButton,
    isCentered = _ref4.isCentered,
    scrollType = _ref4.scrollType;
  return !hideCloseButton && (!isCentered || scrollType === modal_types.ScrollType.CONTAINER) && 'margin-top: 54px;';
}, function (_ref5) {
  var hideCloseButton = _ref5.hideCloseButton,
    isCentered = _ref5.isCentered,
    scrollType = _ref5.scrollType;
  /**
   * The content will be contained within the viewport and overflowed content will be scrollable within.
   * - A separate container ModalContentScrollContainer will be injected so thee close button is not hidden
   * - The scrollbar will be on the right edge of the content
   * - Scrolling with the cursor over the backdrop will not cause the content to scroll
   */
  if (scrollType === modal_types.ScrollType.CONTENT) {
    // If isCentered is true, offset must be doubled to account for space on top and bottom
    var closeButtonOffset = isCentered ? '108px' : '54px';
    // No offset if close button is hidden
    var maxHeight = hideCloseButton ? '100%' : "calc(100% - ".concat(closeButtonOffset, ")");
    return styled.css(["display:flex;flex-direction:column;max-height:", ";"], maxHeight);
  }
  return;
});
var ModalContentScrollContainer = styled__default.div.withConfig({
  displayName: "modalContentstyle__ModalContentScrollContainer",
  componentId: "sc-iz7raj-1"
})(["overflow:auto;overscroll-behavior:contain;"]);

exports.ModalContentContainer = ModalContentContainer;
exports.ModalContentScrollContainer = ModalContentScrollContainer;
